import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=8a411112&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports